import Vue from 'vue'
import vuex from 'vuex'
import userStore from './user.js'
import payStore from './pay'
Vue.use(vuex)

export default new vuex.Store({
  modules: {
    user: userStore,
    pay: payStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js